module.exports = "<div class=\"graph-pe1-container\">\n  \n      <p-chart #mainChart [type]=\"graphType\" [options]=\"graphOptions\" [data]=\"graphData\"></p-chart>\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/graph-pe1/graph-pe1.component.html
// module id = ../../../../../src/app/components/graph-pe1/graph-pe1.component.html
// module chunks = main